/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _echarts = require("./lib/echarts");

(function () {
  for (var key in _echarts) {
    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
    exports[key] = _echarts[key];
  }
})();

var _export = require("./lib/export");

(function () {
  for (var key in _export) {
    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
    exports[key] = _export[key];
  }
})();

require("./lib/component/dataset");

require("./lib/chart/line");

require("./lib/chart/bar");

require("./lib/chart/pie");

require("./lib/chart/scatter");

require("./lib/chart/radar");

require("./lib/chart/map");

require("./lib/chart/tree");

require("./lib/chart/treemap");

require("./lib/chart/graph");

require("./lib/chart/gauge");

require("./lib/chart/funnel");

require("./lib/chart/parallel");

require("./lib/chart/sankey");

require("./lib/chart/boxplot");

require("./lib/chart/candlestick");

require("./lib/chart/effectScatter");

require("./lib/chart/lines");

require("./lib/chart/heatmap");

require("./lib/chart/pictorialBar");

require("./lib/chart/themeRiver");

require("./lib/chart/sunburst");

require("./lib/chart/custom");

require("./lib/component/graphic");

require("./lib/component/grid");

require("./lib/component/legendScroll");

require("./lib/component/tooltip");

require("./lib/component/axisPointer");

require("./lib/component/polar");

require("./lib/component/geo");

require("./lib/component/parallel");

require("./lib/component/singleAxis");

require("./lib/component/brush");

require("./lib/component/calendar");

require("./lib/component/title");

require("./lib/component/dataZoom");

require("./lib/component/visualMap");

require("./lib/component/markPoint");

require("./lib/component/markLine");

require("./lib/component/markArea");

require("./lib/component/timeline");

require("./lib/component/toolbox");

require("zrender/lib/vml/vml");

require("zrender/lib/svg/svg");